import * as React from 'react';

export const ResetPasswordPage = React.lazy(() =>
  import('./ResetPasswordPage')
);
